import { useTheme } from "@emotion/react";
import { capitalize, CircularProgress, Grid, IconButton, MenuItem, Paper, Select, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as CloseIcon } from "../../../assets/close_icon.svg";
import { Primary } from 'ui-components/Buttons';
import { FormikContext, FormikProvider, useFormik } from "formik";
import CustomInputField from "../../../ui-components/formik/CustomInputField";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { InviteInvestorToPipelineInvestors } from "api/investors";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { useToast } from "context/ToastContext";
import { handleFormSubmit } from "utilities/index";
import CustomLabel from "ui-components/CustomLabel";
import CustomValidationText from "ui-components/CustomValidationText";

let emailPattern = /^[^\s@]+@[^\s@]+.[^\s@]+$/;


const InviteInvestorPopup = ({ handleClose, handleSubmit, refetchListing }) => {
  const investor_types = useSelector((state) => state?.startupDetails?.investor_types);
  // console.log(investor_types,"investor_types")
  const theme = useTheme();
  const { addToast } = useToast();
  // const { id: round_id } = useParams();
  const startup_id = Cookies.get("X-ST-ID")
  // const startup_id = useSelector((state) => state.startupDetails.data)?._id;
  const {
    mutateAsync: inviteInvestorAsync,
    isLoading: isInvitingInvestor,
    status: inviteInvestorStatus,
    error: inviteInvestorError,
    data: inviteInvestorResponse
  } = InviteInvestorToPipelineInvestors();
  const validationObj = {
    investor_type: Yup.string()
      .required("Please select investor type")
      .test("is-not-default", "Please select investor type", (value) => value !== "select_investor_type"),
    first_name: Yup.string().trim().required("Please enter first name"),
    last_name: Yup.string().trim().required("Please enter last name"),
    organization_name: Yup.string().when("investor_type", {
      is: (value) => {
        // console.log(value,"value")
        return !value?.toLowerCase().includes("angel") && !value?.toLowerCase().includes("select_investor_type")
      },
      then: (schema) => schema.trim().required("Please enter organization name"),
      otherwise: (schema) => schema.notRequired(),
    }),
    email: Yup.string()
      .required("Please enter email")
      .test("email", "Invalid email address", (value) => emailPattern.test(value)),
    // Uncomment and adjust the message validation if required
    // message: Yup.string().required("Please enter a message"),
  };
  const validationSchema = Yup.object({ ...validationObj });


  const formik = useFormik({
    initialValues: {
      investor_type: "select_investor_type",
      first_name: "",
      last_name: "",
      email: "",
      organization_name: ''
    },
    validateOnMount: false,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      // const formData = new FormData();
      // formData.append("email", values.email);
      // formData.append("message", values.message);
      // formData.append("startup_id", startup_id); 
      // formData.append("startup_round_id", round_id); 

      try {
        await inviteInvestorAsync({
          payload:
          {
            first_name: values?.first_name,
            last_name: values?.last_name,
            email: (values?.email)?.toLowerCase(),
            "organization_name": (values?.organization_name),
            "investor_type": values?.investor_type
          }, _id: startup_id
        }).then((successResponse) => {
          if (successResponse?.data?.statusCode !== 200) {
            // toast.error(successResponse?.data?.message)
            addToast(successResponse?.data?.message, "error")
          }
          else {
            // toast.success(successResponse?.data?.message)
            addToast(successResponse?.data?.message, "success")
          }
          refetchListing()
          handleClose()
        });
      } catch (error) {
        addToast(error?.response?.data?.message, "error")
        // console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  // console.log(formik.errors,"errors")
  return (
    <Paper
      sx={{
        background: theme.palette.customColors.whiteBG,
        borderRadius: "8px",
      }}
    >
      <IconButton sx={{ position: "absolute", top: 20, right: 20, padding: 0 }}>
        <CloseIcon width={40} height={40} onClick={handleClose} />
      </IconButton>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <Grid display={"grid"} container padding={"1.5rem"} gap={"1.5rem"}>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 700,
                  lineHeight: "28px",
                  color: theme.palette.customColors.g300,
                }}
              >
                Invite Investor
              </Typography>
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 500,
                  lineHeight: "24px",
                  color: theme.palette.customColors.g200,
                }}
              >
                Simply add their email address and send the invitation.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid item xs={12} container justifyContent={"space-between"}>
                <Grid item xs={12} sx={{
                  marginBottom: formik.errors?.investor_type ? 1 : 2
                }}>
                  <CustomLabel>Investor Type</CustomLabel>
                  <Select
                    size="small"
                    fullWidth
                    name={`investor_type`}
                    placeholder='Select investor type'
                    value={formik?.values?.investor_type}
                    onChange={formik?.handleChange}
                    sx={{
                      background: theme.palette.customColors.whiteBG,
                      paddingBlock: "6px",
                      margin: 0,
                    }}
                  >
                    <MenuItem value={"select_investor_type"} disabled >Select Investor Type</MenuItem>
                    {investor_types?.map((role) => (
                      <MenuItem key={role?.value} value={role?.value} >
                        {role?.label}
                      </MenuItem>))}
                  </Select>
                  {formik?.errors?.investor_type && <CustomValidationText value={formik?.errors?.investor_type} />}
                </Grid>
                {!formik.values?.investor_type?.toLowerCase()?.includes("angel") && !formik.values?.investor_type?.includes("select_investor_type") && <Grid item xs={12} sm={12}>
                  <CustomInputField
                    name="organization_name"
                    label={"ORGANIZATION NAME"}
                    placeholder={"Enter organization name"}
                    value={formik.values?.organization_name}
                    onChange={(e) => {
                      formik.setFieldValue("organization_name",
                        capitalize(e.target.value));
                    }}
                    sx={{ marginBottom: formik.errors?.organization_name ? 1 : 2 }}
                  />
                </Grid>}
                <Grid item xs={12} sm={5.8}>
                  <CustomInputField
                    name="first_name"
                    label={"FIRST NAME"}
                    placeholder={"Enter first name"}
                    value={formik.values?.first_name}
                    onChange={(e) => {
                      // e.target.value
                      //   ?.charAt(0)
                      //   ?.toUpperCase() +
                      //   e.target.value?.slice(1)
                      formik.setFieldValue("first_name",
                        capitalize(e.target.value));
                    }}
                    sx={{ marginBottom: formik.errors?.last_name ? 1 : 2 }}
                  />

                </Grid>
                <Grid item xs={12} sm={5.8}>
                  <CustomInputField
                    name="last_name"
                    label={"LAST NAME"}
                    placeholder={"Enter last name"}
                    value={formik.values?.last_name}
                    onChange={(e) => {
                      formik.setFieldValue("last_name",
                        capitalize(e.target.value));
                    }}
                    sx={{ marginBottom: formik.errors?.last_name ? 1 : 2 }}
                  />
                </Grid>
              </Grid>
              <CustomInputField
                name="email"
                label={"EMAIL"}
                placeholder={"Enter email"}
                value={formik.values.email}
                onChange={(e) => {
                  formik.setFieldValue("email", String(e.target.value)?.toLowerCase());
                }}
                sx={{ marginBottom: 1 }}
              />
              {/* <CustomInputField
                name="message"
                label={<> MESSAGE <span style={{ color: theme?.palette?.customColors?.g100, textTransform: "none" }}>(Optional)</span></>}
                placeholder={"Enter message"}
                value={formik.values.message}
                onChange={(e) => {
                  formik.setFieldValue("message", e.target.value);
                }}
                multiline
                minRows={3}
              /> */}
            </Grid>
            <Grid item xs={12}>
              <Primary
                type="button"
                onClick={(e) => {
                  handleFormSubmit(e, formik)
                }}
                fullWidth
                sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem", height: '52px' }}
                disabled={isInvitingInvestor}
              >
                {isInvitingInvestor ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.2rem'} /> : "Invite"}
              </Primary>
            </Grid>
          </Grid>
        </form>
      </FormikProvider>
    </Paper>
  );
};

export default InviteInvestorPopup;
